import { apiFetch } from "./api";

export const getRating = async (quarterly, meetingDate) => {
    const obj = {
        method: 'POST',
        body: {
            option: 'get_rating',
            quarterly: quarterly,
            meeting_date: meetingDate
        }
    }

    const response = await apiFetch(obj);

    return response;
};
